import React, {useState} from 'react';
import {Image, Layout, Typography, Form, Input, Button, message, Tabs} from "antd";
import logo from "../Resources/logo.png";
import {MailOutlined} from "@ant-design/icons";
import ModelViewerTile from "./ModelViewerTile";
import {track} from "@amplitude/analytics-browser";

const { Title, Text } = Typography;
const { Header } = Layout;

const PromoTab = (tab) => {
    console.log(tab);

    return {
        label: tab.name,
        key: tab.name,
        children: <div className="flex flex-wrap gap-16 mx-8 justify-center">
            <div className="flex flex-col gap-4">
                <ModelViewerTile
                    className="basis-auto"
                    width={tab.tileSize}
                    height={tab.tileSize}
                    showSelectButton={false}
                    hoverShadow={true}
                    path={tab.firstAssetPath}
                />
                <p className="text-xl font-medium">
                    Original model
                </p>
            </div>

            <div className="flex flex-col gap-4">
                <ModelViewerTile
                    className="basis-auto"
                    width={tab.tileSize}
                    height={tab.tileSize}
                    showSelectButton={false}
                    hoverShadow={true}
                    path={tab.secondAssetPath}
                />
                <p className="text-xl font-medium">
                    {tab.secondAssetPrompt}
                </p>
            </div>

            <div className="flex flex-col gap-4">
                <ModelViewerTile
                    className="basis-auto"
                    width={tab.tileSize}
                    height={tab.tileSize}
                    showSelectButton={false}
                    hoverShadow={true}
                    path={tab.thirdAssetPath}
                />
                <p className="text-xl font-medium">
                    {tab.thirdAssetPrompt}
                </p>
            </div>
        </div>
    };
}

const TexturingEmailCollection = () => {
    const [form] = Form.useForm();
    const [submitting, setSubmitting] = useState(false);

    const delay = ms => new Promise(res => setTimeout(res, ms));

    const onEmailSubmit = async (values) => {
        setSubmitting(true);
        track("texturing_email_collection", { email: values.email });
        await delay(1000);
        message.success("Your email is submitted for an early access. Check your inbox in a while.");
        setSubmitting(false);
    };

    return (
        <div style={{fontFamily: "Avenir"}}>
            <Header className="header">
                <div className="flex flex-row items-center self-center h-16 gap-4">
                    <Image src={logo} preview={false} style={{width: "2rem", height: "2rem"}}/>
                    <Title
                        level={3}
                        style={{color: "white", marginBottom: 0}}
                    >
                        Dimensions
                    </Title>
                </div>
            </Header>

            <div className="flex flex-col items-center justify-items-center mx-16 mt-4 gap-2">
                <div className="flex flex-col items-center justify-items-center mx-16 mt-4 gap-2">
                    <Title style={{fontSize: "4rem", fontWeight: "bold", marginBottom: 0}}>
                        Elevate Your 3D Assets
                    </Title>

                    <Text style={{fontSize: "1.5rem"}}>
                        Rapidly texture your 3D models and get results in seconds.
                        <br/>
                        Only an input asset and desired result description required.
                    </Text>

                    <Form form={form} name="horizontal_email" layout="inline" onFinish={onEmailSubmit}>
                        <div className="flex flex-wrap gap-4 justify-center">
                            <Form.Item
                                name="email"
                                type="email"
                                rules={[
                                    {
                                        required: true,
                                        type: "email",
                                        message: 'Please input your email!',
                                    },
                                ]}
                            >
                                <Input
                                    style={{borderRadius: "0.5rem", width: "16rem"}}
                                    prefix={<MailOutlined className="site-form-item-icon" />}
                                    placeholder="Email"
                                />
                            </Form.Item>
                            <Form.Item shouldUpdate>
                                {() => (
                                    <Button
                                        type="primary"
                                        style={{borderRadius: "0.5rem"}}
                                        htmlType="submit"
                                        loading={submitting}
                                        disabled={
                                            !form.isFieldsTouched(true) ||
                                            !!form.getFieldsError().filter(({ errors }) => errors.length).length
                                        }
                                    >
                                        Get early access
                                    </Button>
                                )}
                            </Form.Item>
                        </div>
                    </Form>
                </div>

                <Text
                    className="mx-8 mt-8 mb-8"
                    style={{fontSize: "1.5rem"}}>
                    Explore the results achieved with Dimensions.
                    <br/>
                    Don't be shy to use rotate and zoom - all assets are interactive.
                </Text>

                <Tabs
                    style={{marginLeft: "8rem", marginRight: "8rem"}}
                    tabPosition="bottom"
                    centered
                    size="large"
                    tabBarGutter={"8rem"}
                    items={[
                        PromoTab({
                            name: "Axe",
                            tileSize: "20rem",
                            firstAssetPath: "/3d-assets/axe/axe_0.glb",
                            secondAssetPath: "/3d-assets/axe/axe_2.glb",
                            secondAssetPrompt: "Axe in a winter style",
                            thirdAssetPath: "/3d-assets/axe/axe_3.glb",
                            thirdAssetPrompt: "Axe in a Halloween style"
                        }),
                        PromoTab({
                            name: "Sword",
                            tileSize: "20rem",
                            firstAssetPath: "/3d-assets/sword/sword_0.glb",
                            secondAssetPath: "/3d-assets/sword/sword_1.glb",
                            secondAssetPrompt: "Sword in a winter style",
                            thirdAssetPath: "/3d-assets/sword/sword_3.glb",
                            thirdAssetPrompt: "Sword in a Halloween style"
                        }),
                        PromoTab({
                            name: "Rifle",
                            tileSize: "20rem",
                            firstAssetPath: "/3d-assets/rifle/rifle_0.glb",
                            secondAssetPath: "/3d-assets/rifle/rifle_1.glb",
                            secondAssetPrompt: "Rifle in a winter style",
                            thirdAssetPath: "/3d-assets/rifle/rifle_3.glb",
                            thirdAssetPrompt: "Rifle in a Halloween style"
                        })
                    ]}
                />
            </div>
        </div>
    );
};

export default TexturingEmailCollection;